import { render, staticRenderFns } from "./DialogVideoAppearance.vue?vue&type=template&id=53782d52&scoped=true"
import script from "./DialogVideoAppearance.vue?vue&type=script&lang=js"
export * from "./DialogVideoAppearance.vue?vue&type=script&lang=js"
import style0 from "./DialogVideoAppearance.vue?vue&type=style&index=0&id=53782d52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53782d52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53782d52')) {
      api.createRecord('53782d52', component.options)
    } else {
      api.reload('53782d52', component.options)
    }
    module.hot.accept("./DialogVideoAppearance.vue?vue&type=template&id=53782d52&scoped=true", function () {
      api.rerender('53782d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogVideoAppearance.vue"
export default component.exports